<template>

  <div>
    <div class="gallery-alert__container">
      <div class="container">
        <div class="row">
          <div class="col-xs-12">
            <h3 class="gallery-alert__heading">Already Ordered?</h3>
            <div class="gallery-header__description">
              <p>
                If you are trying to access the photos from your previous purchase,
                <b>
                  <a
                    href="#"
                    @click="openModal"
                  >
                    click here to access your order.
                  </a>
                </b>
              </p>
            </div>
          </div>
        </div>
      </div>
      <search-email-modal
        :show-modal="modalVisible"
        @close-modal="closeModal"
      />
    </div>
</div></template>

<script>
import SearchEmailModal from './SearchEmailModal'

export default {
  name: 'PreOrderSearchEmail',
  components: {
    SearchEmailModal
  },
  data () {
    return {
      modalVisible: false
    }
  },
  methods: {
    openModal () {
      this.modalVisible = true
    },
    closeModal () {
      this.modalVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// WebResources/vue/proofs/index/components/PreOrderSearchEmail/PreOrderSearchEmail.vue